import { createPropStyling } from '../privatePropStylingUtils';
export const flexboxCssAttrNames = ['alignContent', 'alignItems', 'alignSelf', 'flex', 'flexBasis', 'flexDirection', 'flexGrow', 'flexWrap', 'flexShrink', 'justifyContent', 'justifyItems', 'justifySelf', 'order'];
export const flexboxCssAttrAliases = {
  jc: 'justifyContent'
};
export const flexboxPropStyling = createPropStyling(flexboxCssAttrNames, flexboxCssAttrAliases);
//# sourceMappingURL=flexboxPropStyling.js.map